module.exports = __webpack_public_path__ + "static/assets/a1d153a4ae829fc196c5c7e6b0d7b9f8.svg";